import ApplicationController from './application_controller';

// Connects to data-controller="turbo-frame-loading"
export default class extends ApplicationController {
  static targets = ['content', 'skeleton'];

  static classes = ['busy'];

  connect() {
    super.connect();

    this.showLoader = this.show.bind(this);
    window.addEventListener('turbo:before-fetch-request', this.showLoader);
  }

  disconnect() {
    window.removeEventListener('turbo:before-fetch-request', this.showLoader);
  }

  show(event) {
    if (event.target.dataset.turboFrame === this.element.id) {
      this.contentTarget.classList.add(this.busyClass);
      this.skeletonTarget.classList.remove(this.busyClass);
    }
  }
}
